<h3 class="text-center width-100">
  Topic Search
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>

<!-- 3 STEP PROCESS FORM: SETTINGS, SEARCH LISTING, AND LISTING RESULTS -->
<div class="container-fluid">
  <!-- SIMPLE INPUT -->
  <div class="edit row">
    <div class="col-12">
      <div class="form-group">
        <label for="name">Topic Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Enter Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="color">Topic Title Color</label>
        <br />
        <input
          type="text"
          class="form-control color"
          id="color"
          aria-describedby="Title Color"
          placeholder="Font Color"
          [(ngModel)]="color"
        />
        <button
          role="button"
          type="button"
          aria-label="Choose Color"
          class="btn btn-circle"
          [style.background]="color"
          [(colorPicker)]="color"
        ></button>
      </div>
    </div>
  </div>

  @if (recordsCount > -1) {
    <div class="width-100 margin-15-0 text-center">
      <div class="total-records">
        Total Records Found : {{ recordsCount }}
        <i
          class="fa question-help fa-question-circle-o"
          aria-hidden="true"
          matTooltip="To Narrow Results enter a search term in Advance Search, add a description to the label, and click on button Add Search Chip button.
                            Click on the Update to see it on the page, or just Save and Close."
          [matTooltipPosition]="'right'"
        >
        </i>
      </div>
      <!-- <div><strong _ngcontent-c70="" style="color:red">Please provide one or more valid resources!</strong></div> -->
    </div>
  }

  <ag-advanced-search
    #advanceShowcase
    [topic]="true"
    [grid]="false"
    [embeddedComponent]="true"
    (count)="recordsFound($event)"
    [topicTemplate]="rowChips"
    [chipEdit]="chipEdit"
    (editedChip)="saveTopic($event)"
    [clear]="clear"
  >
  </ag-advanced-search>

  <div class="edit row">
    <!-- ADD SEARCH CHIP -->
    <div class="width-100 text-center padding-15 background-color">
      <!-- INPUT LABEL -->
      @if (showAddTopic) {
        <div style="width: 100%">
          <input
            #chipLabel
            class="form-control inline-block input-action-row"
            style="width: 200px"
            placeholder="Chip Name"
            title="Chip Name"
          />
          <button
            role="button"
            type="button"
            aria-label="Add Search Chip"
            color="primary"
            mat-button
            start
            [disabled]="recordsCount === 0"
            (click)="AddChip($event)"
          >
            Add Search Chip
          </button>
          <i
            class="range-inputs-tooltip fa fa-question-circle-o"
            aria-hidden="true"
            matTooltip="chip name is required to save each search result"
            [matTooltipPosition]="'right'"
          ></i>
        </div>
      }
    </div>

    <div class="col-12">
      <!-- A Representation of the Values placed. -->
      <div class="container-fluid">
        <div class="row" style="padding: 0; margin: 0">
          <!-- using matchip from search facets to display chips -->
          @if (SearchTopic) {
            <div class="col-12">
              <mat-chip-listbox #chipTopic>
                @for (topic of SearchTopic.rowChips; track topic; let i = $index) {
                  <mat-chip-option
                    color="accent"
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeTopic(i)"
                    (click)="editTopic(topic, i)"
                  >
                    {{ topic?.description }}
                    @if (removable) {
                      <mat-icon matChipRemove>
                        <i
                          class="facet-close fa fa-times-circle-o"
                          aria-hidden="true"
                          title="Remove Active Facet"
                        ></i>
                      </mat-icon>
                    }
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- MORE OPTIONS -->
    <div class="col-12">
      <button
        role="button"
        type="button"
        aria-label="More options"
        class="btn btn-link"
        (click)="isCollapsed = !isCollapsed"
      >
        More Options
        @if (isCollapsed) {
          <i class="fa fa-caret-right" aria-hidden="true"></i>
        }
        @if (!isCollapsed) {
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        }
      </button>
    </div>
  </div>
  <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
    <div class="block row text-center">
      <h3>Design Elements</h3>
    </div>
    <div class="edit row">
      <div class="col-12">
        <div class="form-group">
          <label for="topicColor">Topic Font Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="topicColor"
            aria-describedby="Topic Color"
            placeholder="Topic Color"
            [(ngModel)]="topicColor"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="topicColor"
            [(colorPicker)]="topicColor"
          ></button>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="topicBack">Topic Background Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="topicBack"
            aria-describedby="Topic Background"
            placeholder="Topic Background"
            [(ngModel)]="topicBack"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="topicBack"
            [(colorPicker)]="topicBack"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-check">
          <label for="hoverTheme" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="hoverTheme"
              [checked]="hoverTheme"
              [(ngModel)]="hoverTheme"
            />Enable Hover / Focus.
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="background">Background Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="background"
            aria-describedby="Background"
            placeholder="Enter Background Color"
            [(ngModel)]="background"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="background"
            [(colorPicker)]="background"
          ></button>
        </div>
      </div>
    </div>
    <div class="edit row">
      <!-- <div class="col-12 margin-5-0">
                    <div class="form-group">
                      <label for="className">Additional Classes
                        <i class="fa question-help fa-question-circle-o" aria-hidden="true" matTooltip="Add additional classes through the CSS Editor"
                        [matTooltipPosition]="'after'"></i>
                      </label>
                      <input type="text" class="form-control" id="className" aria-describedby="Additional Class Names defined through the CSS Editor"
                        placeholder="class names defined from CSS editor" [(ngModel)]="className">
                      </div>
                    </div> -->
      <div class="col-12 margin-5-0">
        <div class="form-check">
          <label for="flush" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="flush"
              [(ngModel)]="flushed"
            />Flush in template.
          </label>
        </div>
        <div class="form-check">
          <label for="eachRow" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="eachRow"
              [(ngModel)]="eachRow"
            />Show Topic per Row.
          </label>
        </div>
        <hr class="padding-5" />
      </div>
    </div>
  </div>

  <div class="width-100 text-center padding-15 background-color">
    <!-- PREVIEW, UPDATE AND SAVE -->
    @if (SearchTopic !== null || SearchTopic !== undefined) {
      <div class="padding-10 text-end">
        <button
          role="button"
          type="button"
          aria-label="Preview"
          class="btn btn-link"
          (click)="updateTOPIC()"
        >
          Preview
        </button>
        <button
          role="button"
          type="button"
          aria-label="Save and Close"
          class="btn btn-primary"
          (click)="submitTOPIC()"
        >
          Save and Close
        </button>
      </div>
    }
  </div>
</div>
